import React, { Suspense } from 'react';

import type { QueryClient } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { createRootRouteWithContext, Outlet, ScrollRestoration } from '@tanstack/react-router';
import { TanStackRouterDevtools } from '@tanstack/react-router-devtools';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import '~/styles/react-toastify-overrides.css';

import ErrorBoundary from '~/components/error/ErrorBoundary';
import Loading from '~/components/Loading';
import StagingFooter from '~/components/StagingFooter';
import { getStagingOutletPaddingBottomStyle } from '~/components/StagingFooter/stagingFooterPadding';
import { DEVTOOLS } from '~/config';
import { useMetaTags } from '~/hooks/useMetaTags';

// we needed to define the root component in a variable so eslint knows its a react functional component
const RootComponent: React.FC = () => {
    useMetaTags();
    return (
        <>
            <Suspense fallback={<Loading />}>
                <ErrorBoundary>
                    <ScrollRestoration />
                    <div style={getStagingOutletPaddingBottomStyle()}>
                        <Outlet />
                    </div>
                </ErrorBoundary>
                <ToastContainer limit={3} autoClose={5000} hideProgressBar />
            </Suspense>
            <StagingFooter />
            {DEVTOOLS.ENABLED && (
                <>
                    {/* <ReactQueryDevtools initialIsOpen={false} /> */}
                    <Suspense>
                        <TanStackRouterDevtools />
                    </Suspense>
                </>
            )}
        </>
    );
};

export const Route = createRootRouteWithContext<{
    queryClient: QueryClient;
}>()({
    component: RootComponent,
});
